const parseGoogleAddressComponents = (address_components) => {
  const addressAttributesNeeded = {
    street_number: ["street_number"],
    street: ["street_address", "route"],
    line2: ["subpremise", "neighborhood"],
    postal_code: ["postal_code"],
    city: [
      "locality",
      "sublocality",
      "postal_town",
      "sublocality_level_1",
      "sublocality_level_2",
      "sublocality_level_3",
      "sublocality_level_4",
    ],
    country: ["country"],
  };

  const address = {
    street_number: "",
    street: "",
    line2: "",
    postal_code: "",
    city: "",
    country: "",
  };
  address_components.forEach((component) => {
    for (const addressAttribute in addressAttributesNeeded) {
      if (addressAttributesNeeded[addressAttribute].includes(component.types[0])) {
        if (addressAttribute === "country") {
          address[addressAttribute] = component.short_name;
        } else {
          address[addressAttribute] = component.long_name;
        }
      }
    }
  });
  return address;
};

export default parseGoogleAddressComponents;
